import createReactComponent from '../createReactComponent';
var MicOff = createReactComponent('MicOff', [['line', {
  x1: '1',
  y1: '1',
  x2: '23',
  y2: '23',
  key: 'eeof2j'
}], ['path', {
  d: 'M9 9v3a3 3 0 005.12 2.12M15 9.34V4a3 3 0 00-5.94-.6',
  key: '1psk3g'
}], ['path', {
  d: 'M17 16.95A7 7 0 015 12v-2m14 0v2a7 7 0 01-.11 1.23',
  key: '1x86va'
}], ['line', {
  x1: '12',
  y1: '19',
  x2: '12',
  y2: '23',
  key: 'proj2a'
}], ['line', {
  x1: '8',
  y1: '23',
  x2: '16',
  y2: '23',
  key: 'lkkjpw'
}]]);
export default MicOff;